/* @flow */

import { type Poll } from '../utils/api';
import { type Pedido } from './types';
import atualizarEtapaPedido from './atualizar-etapa-pedido';
import pollParaEtapa from './poll-para-etapa';

const atualizarEtapaPedidosPorPolling = (pedidos: Pedido[], polling: Poll[]): Pedido[] => (
    pedidos.map((pedido) => {
        const poll = polling.find(({ pedidosId }) => pedidosId === pedido.id);
        if (!poll) {
            return pedido;
        }
        return atualizarEtapaPedido(pedido, pollParaEtapa(poll));
    })
);

export default atualizarEtapaPedidosPorPolling;
